import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      flex: 1,
      display: 'flex',
      flexDirection: 'row',
      overflow: 'auto',
      zIndex: 0,
    }
  }),
);

export default useStyles;
